import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

// 询价列表
export function getStoreList(data) {
  return axios.request({
    url: `${urlObj.wss}wss-part/activity/findBindJPLeague`,
    method: 'post',
    data,
  })
}
// 询价列表
export function getGoodsList(data,info) {
  return axios.request({
    url: `${urlObj.wss}wss-part/activity/queryActivityGoods?current=${info.current}&&size=${info.size}`,
    method: 'post',
    data,
  })
}